class NullCheckUtil {
    static isNull(input) {
        return input == undefined || input == null;
    }
    static isEmpty(input) {
        return input == undefined || input == null || input == '' || input == 'null';
    }
    static isNotNull(input) {
        return !this.isNull(input);
    }
    static isNotEmpty(input) {
        return !this.isEmpty(input);
    }
}

export default NullCheckUtil;
